<template>
  <div class="feed-footer">
    <div class="feed-handle">
      <ul class="hl_row_line flex">
        <li>
          <span class="handle-text">浏览</span>
          <span class="handle-count">{{ viewCount }}</span>
        </li>
        <li>
          <a href="javascript:;" @click="switchComment">
            <span class="handle-icon comment"></span>
            <span class="handle-count">{{ commentCount }}</span>
          </a>
        </li>
        <li>
          <a href="javascript:;" @click="praiseFeed">
            <span class="handle-icon" :class="praiseStatus"></span>
            <span class="handle-count">{{ praiseCount }}</span>
          </a>
        </li>
        <li>
          <!-- <a href="javascript:;" v-intervalclick='{func:dissFeed,time:5000}'> -->
          <a href="javascript:;" @click="dissFeed">
            <span class="handle-icon" :class="dissStatus"></span>
            <span class="handle-count">{{ dissCount }}</span>
          </a>
        </li>
        <li>
          <a href="javascript:;" @click="switchShare">
            <span class="handle-icon share"></span>
          </a>
        </li>
      </ul>
      <span class="triangle" v-if="unfoldComment"></span>
      <span class="share-triangle" v-show="foldShare"></span>
    </div>
    <div class="feed-comment" v-if="unfoldComment">
      <div class="comment-list" v-loading="commentShade">
        <CommentItem
          v-for="(comment, index) in commentList"
          :key="index"
          :comment="comment"
          :replyList="comment.replyData"
          :replyCount="comment.replyData.length"
          :deleteStatus="comment.isDeleted"
          :showStatus="comment.isShow"
          @handleDelete="deleteComment"
          @handleReload="reloadCommentList"
        />
        <p class="no-comment" v-if="commentList.length == 0">
          {{ noCommentText }}
        </p>
        <div class="pagination-wrapper">
          <el-pagination
            layout="prev, pager, next"
            :total="totalPage"
            prev-text="上一页"
            next-text="下一页"
            hide-on-single-page
            @current-change="curCommentPageClick"
          ></el-pagination>
          <!-- @prev-click="prevCommentPageClick" @next-click="nextCommentPageClick" -->
        </div>
      </div>
      <div class="comment-box">
        <div class="input-wrapper">
          <el-input
            type="textarea"
            resize="none"
            maxlength="100"
            show-word-limit
            :autosize="{ minRows: 2 }"
            placeholder="评论..."
            v-model="commentContent"
          ></el-input>
        </div>
        <div class="comment-btn flex">
          <span></span>
          <el-button
            class="send-comment"
            :disabled="forbidComment"
            @click="submitComment"
            >发表</el-button
          >
        </div>
      </div>
    </div>
    <div class="share-feed-wrap flex" v-show="foldShare">
      <div class="share-text">分享至</div>
      <div>
        <ul class="share-menu flex">
          <li v-for="(item, index) in shareMenu" :key="index">
            <a
              href="javascript:;"
              :class="item.icon"
              @click="initShareFeed(item.command)"
              >{{ item.name }}</a
            >
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import { tranNumber } from "../../utils/feed";
import { apiMap } from "../../utils/apiMap";
import CommentItem from "./comment-item";
// import clickState from "../../utils/clickState";
export default {
  name: "feed-footer",
  props: {
    feed: {
      type: Object,
      required: true,
    },
    scene: {
      type: String,
      required: true,
    },
  },
  components: {
    CommentItem,
  },
  data() {
    return {
      unfoldComment: false,
      praised: false,
      dissed: false,
      commentShade: true,
      commentList: [],
      commentTotal: 0,
      curCommentPage: 1,
      forbidComment: true,
      commentContent: "",
      noCommentText: "",
      foldShare: false,
      shareMenu: [{ name: "传联好友", command: 1, icon: "share-handlian" }],
      canDiss: true,
      dissTimer: null,
    };
  },
  computed: {
    ...mapGetters(["contactBook", "contactsList"]),
    viewCount() {
      if (this.feed && this.feed.readCount) {
        return tranNumber(this.feed.readCount);
      } else {
        return "0";
      }
    },
    commentCount() {
      if (this.feed && this.feed.commentCount) {
        return tranNumber(this.feed.commentCount);
      } else {
        return "0";
      }
    },
    praiseCount() {
      if (this.feed && this.feed.upCount) {
        return tranNumber(this.feed.upCount);
      } else {
        return "0";
      }
    },
    dissCount() {
      if (this.feed && this.feed.downCount) {
        return tranNumber(this.feed.downCount);
      } else {
        return "0";
      }
    },
    praiseStatus() {
      if (this.praised == true) {
        return "praised";
      } else {
        return "unpraise";
      }
    },
    dissStatus() {
      if (this.dissed == true) {
        return "dissed";
      } else {
        return "undiss";
      }
    },
    totalPage() {
      return this.commentTotal;
    },
  },
  mounted() {
    if (this.feed && this.feed.support == 1) {
      this.praised = true;
    } else {
      this.praised = false;
    }
    if (this.feed && this.feed.thread == 1) {
      this.dissed = true;
    } else {
      this.dissed = false;
    }
  },
  methods: {
    switchComment() {
      if (this.unfoldComment == false) {
        this.unfoldComment = true;
        this.foldShare = false;
        this.getCommentList(1);
      } else {
        this.unfoldComment = false;
        (this.commentList = []), (this.commentShade = true);
      }
    },
    getCommentList(start) {
      let $this = this;
      var modelType =
        this.scene == "feedList" ? $this.feed.article : this.feed.modelType;
      let loginUser = JSON.parse(sessionStorage.getItem("userInfo"));
      $this
        .$axios({
          baseURL: apiMap["commonUrl"],
          method: apiMap["commentsList"]["method"],
          url: apiMap["commentsList"]["url"],
          data: `token=${loginUser.token}&modelType=${modelType}&modelId=${this.feed.modelId}&start=${start}&count=10`,
        })
        .then(function(response) {
          $this.commentShade = false;
          if (response.data.result.statusCode == 1) {
            $this.commentTotal = response.data.result.count;
            $this.feed.commentCount = response.data.result.count;
            $this.commentList = response.data.result.data;
          } else {
            $this.noCommentText = "暂无评论";
          }
        })
        .catch(function(error) {
          console.log(error);
        });
    },
    praiseFeed() {
      // var originPraise = this.feed.upCount;
      let _this = this;
      var modelType =
        _this.scene == "feedList" ? _this.feed.article : _this.feed.modelType;
      let loginUser = JSON.parse(sessionStorage.getItem("userInfo"));
      _this
        .$axios({
          baseURL: apiMap["commonUrl"],
          method: apiMap["praiseFeed"]["method"],
          url: apiMap["praiseFeed"]["url"],
          data: `token=${loginUser.token}&modelType=${modelType}&modelId=${_this.feed.modelId}&praiseType=1`,
        })
        .then(function(response) {
          if (response.data.result.statusCode == 1) {
            if (response.data.result.data == 1) {
              _this.praised = true;
              _this.feed.upCount += 1;
            } else {
              _this.feed.upCount -= 1;
              _this.praised = false;
            }
          } else {
          }
        })
        .catch(function(error) {
          console.log(error);
        });
    },
    dissFeed() {
      // var originDiss = this.feed.downCount;
      let _this = this;
      var modelType =
        _this.scene == "feedList" ? _this.feed.article : _this.feed.modelType;
      let loginUser = JSON.parse(sessionStorage.getItem("userInfo"));
      _this
        .$axios({
          baseURL: apiMap["commonUrl"],
          method: apiMap["praiseFeed"]["method"],
          url: apiMap["praiseFeed"]["url"],
          data: `token=${loginUser.token}&modelType=${modelType}&modelId=${_this.feed.modelId}&praiseType=2`,
        })
        .then(function(response) {
          if (response.data.result.statusCode == 1) {
            if (response.data.result.data == 1) {
              _this.dissed = true;
              _this.feed.downCount += 1;
            } else {
              _this.feed.downCount -= 1;
              _this.dissed = false;
            }
          } else {
          }
        })
        .catch(function(error) {
          console.log(error);
        });
    },
    deleteComment(commentID) {
      var findIndex = -1;
      this.commentList.filter((item, index) => {
        if (item.id == commentID) {
          findIndex = index;
        }
      });
      if (findIndex != -1) {
        this.commentList.splice(findIndex, 1);
        this.feed.commentCount -= 1;
      }
    },
    submitComment() {
      let $this = this;
      var modelType =
        this.scene == "feedList" ? $this.feed.article : this.feed.modelType;
      let loginUser = JSON.parse(sessionStorage.getItem("userInfo"));
      $this
        .$axios({
          baseURL: apiMap["commonUrl"],
          method: apiMap["publishComment"]["method"],
          url: apiMap["publishComment"]["url"],
          data: `token=${loginUser.token}&modelType=${modelType}&modelId=${this.feed.modelId}&content=${this.commentContent}`,
        })
        .then(function(response) {
          if (response.data.result.statusCode == 1) {
            var myComment = {
              content: $this.commentContent,
              created_at: Math.round(new Date() / 1000),
              id: response.data.result.data.commentId,
              isDeleted: 0,
              isShow: 1,
              modelId: $this.feed.modelId,
              modelType: $this.feed.article,
              ownerUserId: $this.feed.userId,
              praise: 0,
              praiseStatus: 0,
              replyCount: 0,
              replyData: Array(0),
              updated_at: null,
              userId: loginUser.userId,
              userInfo: {
                headImgUrl: loginUser.headImgUrl,
                name: loginUser.nickName,
                realName: "",
                thumbHeadImg: loginUser.thumbHeadImg,
              },
              userInfoExtend: loginUser.nickName,
            };
            $this.commentList.push(myComment);
            $this.commentContent = "";
            $this.feed.commentCount += 1;
          }
        })
        .catch(function(error) {
          console.log(error);
        });
    },
    prevCommentPageClick(newPage) {
      //即将加载的起始页
      this.commentShade = true;
      this.curCommentPage = newPage;
      this.getCommentList(newPage);
    },
    curCommentPageClick(newPage) {
      //即将加载的起始页
      this.commentShade = true;
      this.curCommentPage = newPage;
      this.getCommentList(newPage);
    },
    nextCommentPageClick(newPage) {
      this.commentShade = true;
      this.curCommentPage = newPage;
      this.getCommentList(newPage);
    },
    reloadCommentList() {
      this.getCommentList(this.curCommentPage);
    },
    switchShare() {
      if (this.foldShare == false) {
        this.unfoldComment = false;
        this.foldShare = true;
      } else {
        this.foldShare = false;
      }
    },
    openFriendList() {
      // console.log(this.contactBook)
      // console.log(this.contactsList)
      let _this = this;
      if (_this.contactBook != 0 && this.contactsList != 0) {
        _this.tryGetDetail((res) => {
          if (res.status == 1) {
            _this.$bus.$emit("open-share-contacts", JSON.stringify(res.data));
          } else {
            var tipHandle = "该动态没有分享到社区，不能分享给好友";
            _this.$message({
              message: tipHandle,
              duration: 1500,
              offset: 230,
            });
          }
        });
      } else {
        _this.$message({
          message: "暂无传联好友",
          duration: 1500,
          offset: 230,
        });
      }
    },
    initShareFeed(action) {
      switch (action) {
        case 1:
          this.openFriendList();
          break;
      }
    },
    tryGetDetail(okCbk) {
      let _this = this;
      var model =
        this.scene == "feedList" ? this.feed.article : this.feed.modelType;
      let loginUser = JSON.parse(sessionStorage.getItem("userInfo"));
      _this
        .$axios({
          baseURL: apiMap["commonUrl"],
          method: apiMap["feedDetail"]["method"],
          url: apiMap["feedDetail"]["url"],
          params: {
            token: loginUser.token,
            modelId: _this.feed.modelId,
            modelType: model,
          },
        })
        .then(function(response) {
          // console.log(response.data.result.data);
          if (response.data.result.statusCode == 1) {
            var res = {
              status: 1,
              data: response.data.result.data,
            };
            okCbk(res);
          } else {
            var res = {
              status: 0,
              data: {},
            };
            okCbk(res);
          }
        })
        .catch(function(error) {
          console.log(error);
        });
    },
  },
  watch: {
    commentContent(text) {
      if (text === "" || text.trim().length === 0) {
        this.forbidComment = true;
      } else {
        this.forbidComment = false;
      }
    },
  },
};
</script>
<style scoped>
.feed-handle {
  position: relative;
}

.hl_row_line {
  justify-content: space-between;
}

.hl_row_line li {
  width: 23%;
  height: 25px;
  line-height: 25px;
}

.handle-text {
  color: #999999;
}

.hl_row_line li:last-child {
  width: 25px;
}

.handle-icon {
  position: relative;
  top: 3px;
  display: inline-block;
  width: 19px;
  height: 17px;
  background-repeat: no-repeat;
  background-size: contain;
}

.handle-count {
  margin-left: 5px;
  color: #e74f52;
}

.comment {
  background-image: url("../../assets/icon/cl_feed_comment.png");
}

.unpraise {
  background-image: url("../../assets/icon/cl_feed_praise.png");
}

.praised {
  background-image: url("../../assets/icon/cl_feed_praised.png");
}

.undiss {
  background-image: url("../../assets/icon/cl_feed_diss.png");
}

.dissed {
  background-image: url("../../assets/icon/cl_feed_dissed.png");
}

.share {
  background-image: url("../../assets/icon/cl_feed_share.png");
}

.feed-comment {
  border: 1px solid #ebebeb;
  box-shadow: 0 1px 3px rgba(26, 26, 26, 0.1);
  background: #fff;
  margin-top: 7px;
  overflow: visible;
  border-radius: 4px;
}

.feed-handle .triangle {
  position: absolute;
  top: 17px;
  left: 196px;
  height: 0;
  width: 0;
  content: "";
  z-index: 1;
  border: 8px solid rgba(0, 0, 0, 0);
  border-bottom-color: #ebebeb;
}

.share-feed-wrap {
  padding: 6px;
  margin-top: 7px;
  font-size: 12px;
  overflow: visible;
  background: #fff;
  border-radius: 4px;
  border: 1px solid #ebebeb;
  box-shadow: 0 1px 3px rgba(26, 26, 26, 0.1);
}

.feed-handle .share-triangle {
  position: absolute;
  top: 17px;
  right: 9px;
  height: 0;
  width: 0;
  content: "";
  z-index: 1;
  border: 8px solid rgba(0, 0, 0, 0);
  border-bottom-color: #ebebeb;
}

.comment-list {
  min-height: 50px;
}

.comment-box {
  padding: 6px 10px;
  border-top: 1px solid #ebebeb;
}

.comment-btn {
  justify-content: space-between;
}

.send-comment {
  padding: 4px 10px;
}

.input-wrapper {
  margin-bottom: 4px;
}

.pagination-wrapper {
  margin: 5px 0;
  text-align: center;
}

.no-comment {
  line-height: 50px;
  text-align: center;
  color: #999;
}

.share-text {
  color: #999999;
  line-height: 30px;
}

.share-menu li {
  margin: 0 20px;
}

.share-menu a {
  display: block;
  height: 28px;
  padding-top: 42px;
  text-align: center;
  line-height: 32px;
  color: #999999;
  background-repeat: no-repeat;
}

.share-handlian {
  background-position: 10px 14px;
  background-image: url("../../assets/icon/cl_share_handlian.png");
}

.share-menu a:hover {
  color: #1a70db;
}
</style>
